module.exports = __webpack_public_path__ + "static/media/logo_blue.cd786857.png";